// import { createSelector } from "reselect";
// import _ from "lodash";


const createSelectors = parentReducer => {
    return new class {
        getToDate = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["DateRangePickerWidget_reducer"];
            return reducer.toDate;
        };
        getFromDate = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["DateRangePickerWidget_reducer"];
            return reducer.fromDate;
        };
    }();
};
export default createSelectors;
